import React from 'react';
import { lightHaptic } from '../../utils/haptics';

export default function NumberPicker({ isOpen, onClose, onSelect, title = 'Select Strokes', min = 1, max = 8 }) {
  if (!isOpen) return null;

  const numbers = Array.from({ length: max - min + 1 }, (_, i) => i + min);

  const handleNumberSelect = (num) => {
    lightHaptic();
    console.log('[NumberPicker] Number selected:', num);
    onSelect(num);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-strong">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ×
          </button>
        </div>

        <div className="grid grid-cols-4 gap-3 mb-3">
          {numbers.map((num) => (
            <button
              key={num}
              onClick={() => handleNumberSelect(num)}
              className="min-h-touch-lg rounded-lg transition-all font-bold text-2xl border-2 bg-gray-100 hover:bg-primary hover:text-white hover:border-primary border-gray-300 active:scale-95"
            >
              {num}
            </button>
          ))}
        </div>
        <button
          onClick={() => handleNumberSelect(0)}
          className="w-full min-h-touch-lg rounded-lg transition-all font-bold text-2xl border-2 bg-gray-100 hover:bg-gray-700 hover:text-white hover:border-gray-700 border-gray-400 text-gray-600 active:scale-95"
        >
          NR
        </button>
      </div>
    </div>
  );
}
